import styled from 'styled-components';

/**
 * Reusable styled component for visually hiding content while keeping it accessible to screen readers.
 * This component generates CSS only once, avoiding duplication.
 *
 * This is useful for accessibility purposes when you need to provide text for screen readers
 * but don't want it visible on the page.
 *
 * @example
 * ```tsx
 * <VisuallyHidden>This text is only for screen readers</VisuallyHidden>
 * ```
 *
 * @example
 * ```tsx
 * <VisuallyHidden as="Typography.Body">Screen reader only text</VisuallyHidden>
 * ```
 */
export const VisuallyHidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
`;
